import { clsx } from 'clsx';
import { EntityDisplayConfigLabel } from './EntityDisplayConfigLabel/EntityDisplayConfigLabel';
import { EntityDisplayConfigValue } from './EntityDisplayConfigValue/EntityDisplayConfigValue';
import { EntityDisplayConfig as EntityDisplayConfigType } from '../../interfaces/entity-display-config';
import { ENTITY_DISPLAY_DETAILS_DATA_IDS } from './dataIds';
import styles from './EntityDisplayConfig.module.scss';
import { EntityActions, EntityActionsProps } from '../../../entity-actions/EntityActions';

export interface EntityDisplayConfigProps {
  className?: string;
  title: string;
  displayConfig: EntityDisplayConfigType;
  actionsProps?: EntityActionsProps<string, unknown>;
  containerClassName?: string;
}

const dataIds = ENTITY_DISPLAY_DETAILS_DATA_IDS;

export function EntityDisplayConfig({
  displayConfig,
  title,
  className,
  actionsProps,
  containerClassName
}: EntityDisplayConfigProps) {
  return (
    <div className={clsx(containerClassName)}>
      <div className={clsx(styles.entityDisplayConfigContainer, className)}>
        <div
          className={clsx('center-flex-row justify-between px-5', styles.entityDisplayConfigHeader)}
        >
          <span className='text-body-2' data-id={dataIds.title}>
            {title}
          </span>

          {actionsProps ? <EntityActions {...actionsProps} /> : null}
        </div>

        <div className={styles.entityDisplayConfigBody}>
          {displayConfig.fields.map(field => (
            <div className='center-flex-row w-100' key={field.name}>
              <EntityDisplayConfigLabel field={field} containerClassName='w-55' />
              <EntityDisplayConfigValue field={field} containerClassName='w-40' />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
